import axios from 'axios';
import Settings from './config';

export default {
    get(id, cb) {
        axios.get(Settings.ENDPOINT + 'api/session/' + id)
            .then(response => {
                cb(response.data);
            });
    },
    beginStay(cb) {
        axios.post(Settings.ENDPOINT + 'api/session/begin/stay')
            .then(response => {
                cb(response.data);
            });
    },
    beginGolf(cb) {
        axios.post(Settings.ENDPOINT + 'api/session/begin/golf')
            .then(response => {
                cb(response.data);
            });
    },
    beginSpa(payload, cb) {
        axios.post(Settings.ENDPOINT + 'api/session/begin/spa', payload)
            .then(response => {
                cb(response.data);
            });
    },
    end(id, cb) {
        axios.post(Settings.ENDPOINT + 'api/session/' + id + '/end',)
            .then(response => {
                cb(response.data);
            });
    },

}